
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Alert from 'vux/src/components/alert/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


var vcity = {
11: '北京',
12: '天津',
13: '河北',
14: '山西',
15: '内蒙古',
21: '辽宁',
22: '吉林',
23: '黑龙江',
31: '上海',
32: '江苏',
33: '浙江',
34: '安徽',
35: '福建',
36: '江西',
37: '山东',
41: '河南',
42: '湖北',
43: '湖南',
44: '广东',
45: '广西',
46: '海南',
50: '重庆',
51: '四川',
52: '贵州',
53: '云南',
54: '西藏',
61: '陕西',
62: '甘肃',
63: '青海',
64: '宁夏',
65: '新疆',
71: '台湾',
81: '香港',
82: '澳门',
91: '国外'
}

function isCardNo(card) {
var reg = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/
if (reg.test(card) === false) {
return false
}
return true
}

function checkProvince(card) {
var province = card.substr(0, 2)
if (vcity[province] === undefined) {
return false
}
return true
}

function checkBirthday(card) {
var len = card.length
var arrData, year, month, day, birthday

if (len === 15) {
var reFifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/
arrData = card.match(reFifteen)
year = arrData[2]
month = arrData[3]
day = arrData[4]
birthday = new Date('19' + year + '/' + month + '/' + day)
return verifyBirthday('19' + year, month, day, birthday)
}

if (len === 18) {
var reEighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X|x)$/
arrData = card.match(reEighteen)
year = arrData[2]
month = arrData[3]
day = arrData[4]
birthday = new Date(year + '/' + month + '/' + day)
return verifyBirthday(year, month, day, birthday)
}
return false
}

function verifyBirthday(year, month, day, birthday) {
var now = new Date()
var nowYear = now.getFullYear()

if (birthday.getFullYear() === parseInt(year) && (birthday.getMonth() + 1) === parseInt(month) && birthday.getDate() === parseInt(day)) {

var time = nowYear - year
if (time >= 3 && time <= 100) {
return true
}
return false
}
return false
}


function checkParity(card) {

card = changeFivteenToEighteen(card)
card = card.replace('x', 'X')
var len = card.length
if (len === 18) {
var arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
var arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
var cardTemp = 0
var valnum = 0
for (var i = 0; i < 17; i++) {
cardTemp += card.substr(i, 1) * arrInt[i]
}
valnum = arrCh[cardTemp % 11]
if (valnum === card.substr(17, 1)) {
return true
}
return false
}
return false
}


function changeFivteenToEighteen(card) {
if (card.length === 15) {
var arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
var arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
var cardTemp = 0
card = card.substr(0, 6) + '19' + card.substr(6, card.length - 6)
console.log(card)
for (var i = 0; i < 17; i++) {
cardTemp += card.substr(i, 1) * arrInt[i]
}
card += arrCh[cardTemp % 11]
return card
}
return card
}

function checkCard(card) {

if (isCardNo(card) === false) {
return false
}

if (checkProvince(card) === false) {
return false
}

if (checkBirthday(card) === false) {
return false
}

if (checkParity(card) === false) {
return false
}
return true
}


function fun(value) {
var pat = new RegExp("[^a-zA-Z0-9\_\u4e00-\u9fa5]", "i");
if (pat.test(value)) {
return false
}
return true
}

export default {
components: {
Group,
XInput,
XHeader,
XButton,
Toast,
Selector,
Alert,
XImg,
CheckIcon
},
name: 'register',
data() {
return {
newmobile: '',
name: '',
idcard: '',
mobile: '',
company: '',
passwd: '',
passwd2: '',
registerType: this.$route.query.role,
openid: '',
rcmd: '',
smsCode: '',
list: [{key: 'users', value: '个人用户'}, {key: 'expert', value: '个人专家'}],
checkidCard: function (value) {
return {
valid: checkCard(value),
msg: '身份证号码错误'
}
},
smsDisabled: true,
buttonText: '获取验证码',
isDisabled: true,
isChecked: false,
checkName: function (value) {
return {
valid: fun(value),
msg: '用户名错误'
}
}
}
},
methods: {
handleDisabled: function () {
this.isChecked = !this.isChecked
this.isDisabled = this.isChecked !== true;
},
registerSubmit() {
var app = this
if (this.$refs.input1.valid && this.$refs.input2.valid && this.$refs.input3.valid && this.$refs.input4.valid && this.$refs.input5.valid && this.$refs.input6.valid && this.$refs.input7.valid && this.name && this.idcard && this.mobile) {
if (this.checkValidatecode() && this.newmobile == this.mobile) {
let info = {
'code': this.smsCode,
'mobile': this.mobile
}
this.$http.put('/api/v1/accounts/checksms', info).then(res => {
let idcard = this.idcard.replace('x', 'X')
var userInfo = {
'name': this.name,
'idcard': idcard,
'mobile': this.mobile,
'passwd': this.passwd,
'account': this.mobile,
'openid': this.openid,
'rcmd': this.rcmd,
company:this.company
}
let url
url = this.registerType === 'expert' ? '/api/v1/experts/wechat' : '/api/v1/users/wechat';
this.$http.post(url, userInfo).then(() => {
app.$vux.toast.show({
text: '注册成功',
type: 'success',
time: '1000'
})
localStorage.setItem('account', userInfo.account)
if (localStorage.getItem('history')) {
app.$router.push({name: 'attention', query: {id: localStorage.getItem('history')}})
return
}
if (localStorage.getItem('repair')) {
this.$router.push({name: "normalrepairs"});
return
}
app.$router.push({name: 'vip'})
}).catch((error) => {
let code = JSON.parse(error.response.data.error_message).faultcode
if (code === 11013 || code === 11003) {
app.$vux.toast.show({
text: '用户已注册，正在登录',
type: 'success',
time: '2000'
})
this.$http.post("/api/v1/accounts", {
passwd: this.smsCode,
account: this.mobile,
is_passwd: false,
tp:'mobile'
}).then(response => {
localStorage.setItem("account", app.account);
localStorage.setItem("token", response.data.token);
localStorage.setItem("userid", response.data.userid);
const unionid = localStorage.getItem('unionid')

const nickname = localStorage.getItem('nickname')
const imgurl = localStorage.getItem('imgurl')
let obj = {
account: response.data.userid.toString(),
unionid:unionid,
nickname:nickname,
imgurl:imgurl,
otp:'official'
};
let openid = localStorage.getItem("openid");
let head = {
headers: {
token: response.data.token,
opid: response.data.userid
}
};
this.$http.post("/api/v1/wechat/" + openid, obj, head).then(() => {
if (localStorage.getItem('history')) {
this.$router.push({
name: "attention", query: {id: localStorage.getItem('history')}
});
return
}
if (localStorage.getItem('repair')) {
this.$router.push({name: localStorage.getItem('repair')});
return
}
app.$router.push({name: 'vip'})
}).catch(() => {
this.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
})
})
} else {
this.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
}
})
}).catch(err => {
console.log(err.response)
app.$vux.alert.show({
title: '',
content: '验证码错误或已过期'
})
})

} else {
this.$vux.alert.show({
title: '',
content: '验证码错误或已过期'
})
}
} else {
if (!(this.$refs.input1.valid && this.$refs.input2.valid && this.$refs.input3.valid && this.$refs.input4.valid && this.$refs.input5.valid)) {
this.$vux.alert.show({
title: '',
content: '输入信息有误'
})
} else {
this.$vux.alert.show({
title: '',
content: '输入信息不完整'
})
}
}
},
getSmscode: function () {
var info = {
nationcode: '86',
mobile: this.mobile
}
this.newmobile = info.mobile
var app = this
this.$http.post('/api/v1/accounts/sms', info)
.then(function (response) {
console.log(response)
if (response.data.result === 0) {
var validateCode = {
timestamp: parseInt(new Date().getTime() / 1000),

}
localStorage.setItem('validateCode', JSON.stringify(validateCode))
} else {
app.$vux.alert.show({
title: '',
content: response.data.errmsg
})
}
})
.catch(function (error) {
if (error.response) {
console.log(error.response.data)
if (error.response.data.error_message) {
app.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).faultstring
})
}
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
sessionStorage.setItem('countDown', 60)
if (app.buttonText === '获取验证码') {
app.timeKeeping()
} else {
app.againTime()
}
},
checkValidatecode() {
let validateCode = localStorage.getItem('validateCode')
if (validateCode) {
validateCode = JSON.parse(validateCode)
var currentTime = parseInt(new Date().getTime() / 1000)
return (currentTime - validateCode.timestamp < 600);
}
},
timeKeeping() {
this.smsDisabled = true
var app = this
clearInterval(interval)
var interval = setInterval(function () {

var countDown = parseInt(sessionStorage.getItem('countDown'))

app.buttonText = countDown + '秒'

if (countDown === 0) {
clearInterval(interval)
sessionStorage.removeItem('countDown')
app.buttonText = '重新发送'
app.smsDisabled = false
} else {
countDown--
sessionStorage.setItem('countDown', countDown)
}
}, 1000)
},
againTime() {
this.smsDisabled = true
let app = this
var timer = setInterval(function () {
let countDown = parseInt(sessionStorage.getItem('countDown'))
app.buttonText = countDown + '秒'
if (countDown === 1) {
clearInterval(timer)
sessionStorage.setItem('countDown', NaN)
app.buttonText = '重新发送'
app.smsDisabled = false
}
}, 1000)
}
},

beforeRouteEnter(to, from, next) {
let unionid = localStorage.getItem('unionid')
AjaxPlugin.$http.get('/api/v1/wechat/' + unionid)
.then(function (response) {



if (response.data.length > 0) {
next({
path: '/'
})
} else {
if (from.name === 'protocal') {
let regData = localStorage.getItem('regData')
if (regData) {
regData = JSON.parse(regData)
next(vm => {
vm.openid = openid
vm.name = regData.name
vm.idcard = regData.idcard
vm.mobile = regData.mobile
vm.passwd = regData.passwd
vm.passwd2 = regData.passwd2
vm.registerType = regData.registerType
vm.rcmd = regData.rcmd
vm.smsCode = regData.smsCode
vm.newmobile = regData.newmobile
vm.isDisabled = regData.isDisabled
vm.isChecked = regData.isChecked
vm.company = regData.company
})
}
next(vm => {
vm.openid = openid
})
}
next(vm => {
vm.openid = openid
})
}
})
.catch(function (error) {
this.$vux.alert.show({
title: '',
content: '服务器错误，请稍后重试'
})
if (error.response) {
console.log(error.response.data)
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
},
beforeRouteLeave(to, from, next) {
if (to.name === 'protocal') {
var regData = {
name: this.name,
idcard: this.idcard,
mobile: this.mobile,
passwd: this.passwd,
passwd2: this.passwd2,
registerType: this.registerType,
rcmd: this.rcmd,
smsCode: this.smsCode,
newmobile: this.newmobile,
isDisabled: this.isDisabled,
isChecked: this.isChecked,
company: this.company
}
localStorage.setItem('regData', JSON.stringify(regData))
} else {
localStorage.removeItem('regData')
}
next()
},
created() {
let countDown = sessionStorage.getItem('countDown')
if (countDown && countDown !== 'NaN') {
this.againTime()
} else if (countDown == 'NaN') {
this.buttonText = '重新发送'
this.smsDisabled = false
} else {
this.smsDisabled = false
}
}
}



// WEBPACK FOOTER //
// ./src/components/login/register.vue